import React from "react";
import { useResortMenuStore } from "../../store/resortMenuStore";
import { Checkbox, Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { ExpandLess, ExpandMore, StarBorder } from "@mui/icons-material";

type SubMenuItemProps = {
  title: string;
  options: string[];
  index: number;
};

const MobileSubMenuItem = ({ title, index, options }: SubMenuItemProps) => {
  const { openSubMenuIndex, setOpenSubMenuIndex, toggleMenuOpen, setParams, closeSubMenu, isInParams} = useResortMenuStore();

  const [open, setOpen] = React.useState(false);

  const isOpen = openSubMenuIndex == index;

  const handleOptionClick = (event: React.MouseEvent, item: string, title : string) => {
    event.stopPropagation();
    //closeSubMenu()
    if (!event.currentTarget) return;

    const newTitle = mapOptionToACF(title)
    if ( newTitle == undefined ) return

    setParams({ 
      name : newTitle,  
      value : item,
      label : item
    });
    
  };

  const mapOptionToACF = (title : string) => {
    const titleLowered = title.toLowerCase()
    switch ( titleLowered ) {
      case 'resort size' : 
        return 'size';

      default : return titleLowered;
    }
  }

  const handleClick = () => {
    setOpen(!open);
  };

  return (
      <React.Fragment>
        <ListItemButton onClick={handleClick}>
          <ListItemText primary={title} 
            primaryTypographyProps={{fontSize: '16px', fontFamily: 'inherit'}}
            sx={{fontFamily: 'inherit', fontSize:'16px'}} />
          {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {(options as []).map((item, index) => (
              <ListItemButton sx={{ pl: 4 }}
                onClick={(event) => {
                  handleOptionClick(event, item, title);
                }}
                key={index}
              >
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={isInParams(item)}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ 'aria-labelledby': title }}
                  />
                </ListItemIcon>
                <ListItemText 
                  primaryTypographyProps={{fontSize: '16px', fontFamily: 'inherit'}}
                  sx={{fontFamily: 'inherit', fontSize: '16px'}} id={title} primary={item} />
              </ListItemButton>
            ))}
        </List>
      </Collapse>
      </React.Fragment>
  );
};

export default MobileSubMenuItem;
